import { registerPlugin } from '@capacitor/core';
const EdgeToEdge = registerPlugin('EdgeToEdge', {});
export * from './definitions';
export { EdgeToEdge };
//# sourceMappingURL=index.js.map